import React from "react";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";

import { PageHeader } from "../../components/v3";
import { AddEditPlanForm } from "../../components/superadmin";
import { PageLayout } from "../../layouts/PageLayout";

export const AddEditPlan = () => {
  const { id, planId } = useParams();

  return (
    <PageLayout>
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <PageHeader title={planId ? "Edit Plan" : "Add Plan"} />
      </Box>

      <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
        <AddEditPlanForm companyId={id} planId={planId} />
      </Box>
    </PageLayout>
  );
};
